import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  OutlinedInput,
} from '@material-ui/core';

import { getUserId } from '../../helpers/common';
import * as statisticsActionMgr from '../../station-statistics/action-mgr';
import * as statisticsReducers from '../../station-statistics/reducer';
import * as healthDataActionMgr from '../../health-data/action-mgr';

const styles = theme => ({
  wrapper:        { padding: theme.spacing * 2 },
  metricRow:      { display: 'flex', alignItems: 'center', marginBottom: 2 },
  headlineLabel:  { fontSize: 12, color: theme.palette.text.secondary, fontWeight: 500 },
  headlineValue:  { fontWeight: 600, marginLeft: theme.spacing / 2 },   // a small gap
});


class DashboardPortfolioInfo extends Component {
  componentDidMount() {
    const {
      callPortfolioInfo,
      selectedPortfolioInfoCompany,
      portfolioInfo,
      callPortfolioTotalize,
    } = this.props;

    const userId = getUserId();
    const companyName = selectedPortfolioInfoCompany || portfolioInfo.companies?.[0];

    const request = {
      userId,
      ...(companyName && { company: companyName }),
    };

    callPortfolioInfo(request);
    callPortfolioTotalize(request);
  }

  componentDidUpdate(prevProps) {
    const { portfolioInfo, selectedPortfolioInfoCompany, callHeatMapData, clearHeatMapData, } = this.props;
    if (
      prevProps.portfolioInfo.companies !== portfolioInfo.companies &&
      portfolioInfo.companies?.length &&
      !selectedPortfolioInfoCompany
    ) {
      const first = portfolioInfo.companies[0];
      this.handleCompanyChange(first);
    }
    const prevStations = prevProps.portfolioInfo.stations || [];
    const currStations = portfolioInfo.stations || [];

    if (
      currStations.length &&
      prevStations !== currStations
    ) {
      const stationNames = currStations.map(stn =>
        typeof stn === 'string' ? stn : stn.name
      );

      clearHeatMapData(); // clear old PR data
      callHeatMapData({ stations: stationNames }); // fetch fresh
    }
  }

  handleCompanyChange = company => {
    const {
      setSelectedPortfolioCompany,
      callPortfolioInfo,
      callPortfolioTotalize,
    } = this.props;

    const userId = getUserId();

    setSelectedPortfolioCompany(company);        // update local choice

    const request = { userId, company };
    callPortfolioInfo(request);                  // fetch new portfolio
    callPortfolioTotalize(request);              // fetch totals
  };


  render() {
    const {
      classes,
      portfolioInfo,
      portfolioTotalize,
      selectedPortfolioInfoCompany,
    } = this.props;

    const currentYear = new Date().getFullYear();
    const isAdmin     = portfolioInfo.userRole === 'admin';

    return (
      <Grid container spacing={8} className={classes.wrapper}>
        <Grid item xs={12} md={5} style={{ padding: '12px 12px' }}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            className={classes.formControlWrapper}
          >
            <InputLabel>Company</InputLabel>
            <Select
              value={selectedPortfolioInfoCompany || ''}
              onChange={e => this.handleCompanyChange(e.target.value)}
              input={
                <OutlinedInput
                  labelWidth={60}
                  className={classes.formControlSelect}
                />
              }
              disabled={!isAdmin}
            >
              {(portfolioInfo.companies || []).map((c, idx) => (
                <MenuItem key={idx} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} md={3}>
            <div className={classes.metricRow}>
                <Typography className={classes.headlineLabel}>Total Stations: &nbsp;</Typography>
                <Typography className={classes.headlineValue}>
                  {portfolioInfo.totalStations ?? '--'}
                </Typography>
            </div>

            <div className={classes.metricRow}>
                <Typography className={classes.headlineLabel}>Total Avg PR: &nbsp;</Typography>
                <Typography className={classes.headlineValue}>
                  {portfolioTotalize.avgAnnualPerformanceRatio ?? '--'}%
                </Typography>
            </div>
        </Grid>

        <Grid item xs={6} md={4}>
            <div className={classes.metricRow}>
                <Typography className={classes.headlineLabel}>
                Total System Capacity&nbsp;({currentYear}): &nbsp;
                </Typography>
                <Typography className={classes.headlineValue}>
                  {portfolioTotalize.totalAnnualSystemCapacity?.toLocaleString() ?? '--'} kWp
                </Typography>
            </div>

            <div className={classes.metricRow}>
                <Typography className={classes.headlineLabel}>
                 Total Energy Yields&nbsp;({currentYear}): &nbsp;
                </Typography>
                <Typography className={classes.headlineValue}>
                  {portfolioTotalize.totalAnnualEnergyYields?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ?? '--'} MWh
                </Typography>
            </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  portfolioInfo: statisticsReducers.getPortfolioInfo(state),
  selectedPortfolioInfoCompany: statisticsReducers.getSelectedPortfolioInfoCompany(state),
  portfolioTotalize: statisticsReducers.getPortfolioTotalize(state),
});

const mapActionsToProps = {
  callPortfolioInfo: statisticsActionMgr.callPortfolioInfo,
  callPortfolioTotalize: statisticsActionMgr.callPortfolioTotalize,
  callHeatMapData: healthDataActionMgr.fetchLatestPRData,
  clearHeatMapData: healthDataActionMgr.clearLatestPRData, 
  setSelectedPortfolioCompany: statisticsActionMgr.setPortfolioInfoCompany
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(DashboardPortfolioInfo));
